import { SvgIcon, SvgIconProps } from '@mui/material';

const DashboardIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_16037_2435"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_16037_2435)">
      <mask
        id="mask1_16037_2435"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="currentColor" />
      </mask>
      <g mask="url(#mask1_16037_2435)">
        <path
          d="M20.1286 26V17.4617H28.6669V26H20.1286ZM14.7953 14.5383V6H28.6669V14.5383H14.7953ZM3.33359 26V17.4617H17.2053V26H3.33359ZM3.33359 14.5383V6H11.8719V14.5383H3.33359ZM16.7949 12.5387H26.6669V8H16.7949V12.5387ZM5.33359 24H15.2056V19.4613H5.33359V24ZM22.1283 24H26.6669V19.4613H22.1283V24ZM5.33359 12.5387H9.87225V8H5.33359V12.5387Z"
          fill="currentColor"
        />
      </g>
    </g>
  </SvgIcon>
);

export default DashboardIcon;
